<template>
  <div class="setMenus">
    <OATable :data="data" :columns="columns" :filterData="filterData" @search="handleSearch" :loading="loading"
      :selectionRow="true" @selectionChange="selectionChange">
      <div slot="button">
        <OAButton @click="add">添加</OAButton>
        <OAButton @click="edit" class="pull-right" type="warning" :disabled="!checkList.length">编辑</OAButton>
        <OAButton @click="remove" class="pull-right" type="danger" :disabled="!checkList.length">删除</OAButton>
      </div>
    </OATable>
    <OAModalForm :title="titleText" :visible.sync="dialogVisible" :form-data="formData" @on-submit="submit"
      @on-cancel="dialogVisible = false" labelWidth="140px"></OAModalForm>
  </div>
</template>
<script>
  import OAModalForm from "@/components/OAModalForm/OAModalForm";
  import {
    resFilter,
    setValue
  } from "@/common/util.js";
  import setMenusApi from "@/services/setMenus.js";
  import commonApi from "@/services/common.js";
  import {
    isTrue
  } from "@/common/dictionary.js";

  export default {
    name: "setMenus",
    components: {
      OAModalForm
    },
    data() {
      return {
        filterData: {
          ids: {
            formType: "a-cascader",
            value: undefined,
            col: 4,
            api: "getAllPermission",
            placeholder: "所属应用",
            options: []
          },
          includeChild: {
            formType: "a-select",
            value: undefined,
            col: 4,
            placeholder: "是否包含子集",
            options: isTrue
          },
          type: {
            formType: "a-select",
            value: undefined,
            col: 4,
            api: "getLevel",
            placeholder: "权限等级",
            options: []
          },
          operator: {
            formType: "a-auto-search",
            value: undefined,
            apiType: "getAll",
            col: 4,
            placeholder: "操作人"
          },
          createTimeList: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "录入开始日期",
            endPlaceholder: "录入结束日期",
            col: 4
          }
        },
        columns: [{
            title: "所属应用",
            key: "code"
          },
          {
            title: "权限等级",
            key: "type"
          },
          {
            title: "权限名称",
            key: "name"
          },
          {
            title: "排序",
            key: "sort"
          },
          {
            title: "权限路由",
            key: "englishName"
          },
          {
            title: "操作人",
            key: "operator"
          },
          {
            title: "录入时间",
            key: "createTime",
            minWidth: 100
          }
        ],
        formData: {
          ids: {
            formType: "a-cascader",
            value: undefined,
            placeholder: "请选择所属模块",
            label: "所属模块：",
            api: "getAllPermission",
            rules: [{
              required: true,
              message: "请选择所属模块"
            }]
          },
          name: {
            formType: "a-input",
            value: undefined,
            placeholder: "请输入权限名称",
            label: "权限名称：",
            rules: [{
              required: true,
              message: "请输入权限名称"
            }]
          },
          englishName: {
            formType: "a-input",
            value: undefined,
            placeholder: "请输入权限路由",
            label: "权限路由：",
            rules: [{
              required: true,
              message: "请输入权限路由"
            }]
          },
          sort: {
            formType: "a-input-number",
            value: undefined,
            placeholder: "请输入排序",
            label: "排序：",
            rules: [{
              required: true,
              message: "请输入排序"
            }]
          }
        },
        data: [],
        dialogVisible: false,
        loading: false,
        titleText: "",
        checkList: [],
        form: {},
        id: ""
      };
    },
    methods: {
      async handleSearch(val) {
        this.loading = true;
        this.param = val;
        let res = await setMenusApi.getMenusList(val);
        this.data = res.data.data;
        this.loading = false;
      },
      selectionChange(selection) {
        this.checkList = selection;
      },
      add() {
        this.dialogVisible = true;
        this.titleText = "添加权限";
        this.id = "";
      },
      edit() {
        if (this.checkList.length > 1) {
          this.$message.warning("不支持批量操作");
        } else {
          this.dialogVisible = true;
          this.titleText = "修改权限";
          this.form = setValue(this.checkList[0], this.formData);
          this.id = this.checkList[0].id;
        }
      },
      async submit(val) {
        let res;
        if (this.id) {
          val["id"] = this.id;
          res = await setMenusApi.editMenus(val);
        } else {
          res = await setMenusApi.addMenus(val);
        }
        resFilter(res, this.handleSearch(this.param));
        this.dialogVisible = false;
      },
      remove() {
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          let ids = this.checkList.map(item => item.id);
          let res = await setMenusApi.deleteMenus({
            ids: ids
          });
          resFilter(res, this.handleSearch(this.param));
        }).catch(() => {});
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/set/setMenus.vue